module.exports = __webpack_public_path__ + "static/media/arrow-right.4d626473.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-right.svg
// module id = 931
// module chunks = 0